'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var size = {
  small: '5px',
  regular: '10px',
  large: '20px'
};
exports.default = size;